/* eslint-disable no-unused-vars */
import Reactotron from 'reactotron-react-js';
import { reactotronRedux } from 'reactotron-redux';
import reactotronSaga from 'reactotron-redux-saga';

declare global {
  interface Console {
    tron: any;
  }
}

const tron = Reactotron.configure({})
  .use(reactotronRedux())
  .use(reactotronSaga({ except: [''] }) as any)
  .connect();

// eslint-disable-next-line no-console
console.tron = tron;

if (tron) {
  (tron as any).clear();
}

export default tron;
